export const manualAdjustmentReportDataSelector = ({ consolidation }) =>
  consolidation.manualAdjustmentReport.manualAdjustmentReportData;

export const isFetchingManualAdjustmentReportDataSelector = ({ consolidation }) =>
  consolidation.manualAdjustmentReport.isFetchingManualAdjustmentReportData;
